export const LoyaltyProgramGridPluginSettings: IPluginSettings = {
    name: 'Программы лояльности',
    mnemocode: 'loyalty_program_plugin',
    permission: 'LoyaltyProgram',
    columns: [{
        order: 0,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 400
    },
    {
        order: 1,
        propertyName: 'isEnabled',
        propertyType: 'boolean',
        displayName: 'Активна',
        visibility: true,
        width: 150
    },
    {
        order: 2,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 160
    },
    {
        order: 3,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: false,
        width: 160
    },
    {
        order: 4,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: false,
        width: 160
    }
    ]   
}